import * as ActionTypes from './types';

export function deleteCriterion(payload) {
    return {
        type: ActionTypes.DELETE_CRITERION,
        payload: payload
    }
}

export function deleteCriterionSuccess(payload) {
  return {
    type: ActionTypes.DELETE_CRITERION_SUCCESS,
    payload: payload
  }
}

export function deleteCriterionFailed(payload) {
  return {
    type: ActionTypes.DELETE_CRITERION_FAILED,
    payload: payload
  }
}

export function changeCriterionState(payload) {
  return {
    type: ActionTypes.CHANGE_CRITERION_STATE,
    payload: payload
  }
}

export function updateCriterion(payload) {
  return {
    type: ActionTypes.UPDATE_CRITERION,
    payload: payload
  }
}

export function updateCriterionSuccess(payload) {
  return {
    type: ActionTypes.UPDATE_CRITERION_SUCCESS,
    payload: payload
  }
}

export function updateCriterionFailed(payload) {
  return {
    type: ActionTypes.UPDATE_CRITERION_FAILED,
    payload: payload
  }
}

export function getCriterionById(payload) {
  return {
    type: ActionTypes.GET_CRITERION_BY_ID,
    payload: payload
  }
}

export function getCriterionByIdSuccess(payload) {
  return {
    type: ActionTypes.GET_CRITERION_BY_ID_SUCCESS,
    payload: payload
  }
}

export function getCriterionByIdFailed(payload) {
  return {
    type: ActionTypes.GET_CRITERION_BY_ID_FAILED,
    payload: payload
  }
}

export function createCriterion(payload) {
  return {
    type: ActionTypes.CREATE_CRITERION,
    payload: payload
  }
}

export function createCriterionSuccess(payload) {
  return {
    type: ActionTypes.CREATE_CRITERION_SUCCESS,
    payload: payload
  }
}

export function createCriterionFailed(payload) {
  return {
    type: ActionTypes.CREATE_CRITERION_FAILED,
    payload: payload
  }
}



// WEBPACK FOOTER //
// ./src/actions/criterion.js